import $ from 'jquery';

const removeAcfToggleElements = () => {
	$('.is-hidden').each(function () {
		const $el = $(this);
		const $parent = $el.parent();

		if ($parent.length && $parent.hasClass('elementor-heading-title')) {
			$parent.contents().each(function () {
				if (
					this.nodeType === 3 &&
					(this.nodeValue.includes('verblijfskosten') ||
						this.nodeValue.includes('excl.'))
				) {
					$(this).remove();
				}
			});
			$parent.find('br').remove();
			$el.remove();

			if (!$.trim($parent.text())) {
				$parent.closest('.elementor-widget').remove();
			}
		} else {
			$el.remove();
		}
	});
};

$(function () {
	removeAcfToggleElements();
	$(window).on('elementor/frontend/init', removeAcfToggleElements);
});

export default removeAcfToggleElements;
